/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectPenaltiesQuery } from '../../models/get-project-penalties-query';
import { GetProjectPenaltiesQueryResult } from '../../models/get-project-penalties-query-result';

export interface ApiProjectPenaltiesGetProjectPenaltiesPost$Params {
      body?: GetProjectPenaltiesQuery
}

export function apiProjectPenaltiesGetProjectPenaltiesPost(http: HttpClient, rootUrl: string, params?: ApiProjectPenaltiesGetProjectPenaltiesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectPenaltiesQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectPenaltiesGetProjectPenaltiesPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectPenaltiesQueryResult>;
    })
  );
}

apiProjectPenaltiesGetProjectPenaltiesPost.PATH = '/api/ProjectPenalties/GetProjectPenalties';
